import { toast } from '@krakentech/coral';

import { useForceReauthentication } from '@/hooks/auth/useForceReauthentication';

export const useLogout = () => {
  const displayError = () => {
    toast('There was a problem logging you out, please try again', {
      type: 'error',
    });
  };
  const { mutate, isPending } = useForceReauthentication({ displayError });

  const logout = () => {
    mutate({
      input: {
        includeThirdParties: true,
      },
    });
  };

  return { logout, isPending };
};
